import React from "react";
import { Card, Typography, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import styled from "styled-components";

const { Title, Paragraph } = Typography;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: lightblue;
  padding: 50px 20px;
  @media (max-width: 768px) {
    padding: 30px 15px;
  }
`;

const StyledCard = styled(Card)`
  width: 90%;
  max-width: 1000px;
  background: linear-gradient(135deg, #1d4ed8, #3b82f6);
  color: white;
  border-radius: 16px;
  padding: 40px;
  text-align: center;
  @media (max-width: 768px) {
    padding: 25px;
  }
`;

const FounderContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-top: 40px;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    gap: 30px;
    flex-direction: column;
    align-items: center;
  }
`;

const FounderCard = styled.div`
  text-align: center;
  margin-top: 20px;
`;

const StyledParagraph = styled(Paragraph)`
  color: white;
  text-align: justify;
  max-width: 900px;
  margin: 0 auto;
  font-size: 1.5rem;

  @media (max-width: 768px) {
    font-size: 1.25rem;
    text-align: left;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const About = () => {
  return (
    <PageContainer>
      <StyledCard>
        <Title level={2} style={{ color: "white" }}>Our Story</Title>
        <StyledParagraph>
          The story of Chronoflow begins with my own experience of navigating a frustrating and honestly, pretty disheartening job search across different parts of the world. After I moved to the U.S,  I had high hopes from the U.S. recruitment system being more advanced and better, but it turned out to be just as broken. The interesting part was that recruiters would reach out with opportunities, which was a nice change, but then, they'd just... go silent. No follow-ups, no updates or feedback.<br /><br />

          After two months of struggling for job, I was curious to know that why these recruiters can't have a better system in place despite lots of advancements made in this field. So I reached out to dozens of agency recruiters who contacted me for potential job opportunities and then ghosted. I was surprised to know that those recruiters were actually really nice! Turns out, they genuinely wanted to keep me in the loop, to give me feedback, because they knew that's how it should be. But they were swamped, completely overwhelmed with manual work that updating every candidate was too much to take.<br /><br />

          So, I got pretty much idea of what recruiters want but in order to completely understand the recruitment system, I started working as a recruiter myself to actually manually perform all the tasks before automating them.<br /><br />

          We are two cool engineers on a mission to break communication barriers between recruiters, hiring managers and candidates for higher candidate retention and faster placements.<br/> <br/>
          Written by: Ammara
        </StyledParagraph>
        <FounderContainer>
          <FounderCard>
            <Avatar size={100} icon={<UserOutlined />} alt="Founder Avatar" />
            <Title level={4} style={{ color: "white", marginTop: "10px" }}>Ammara Mehd Ghani</Title>
            <Paragraph style={{ color: "white" }}>Co-Founder & CEO</Paragraph>
          </FounderCard>
          <FounderCard>
            <Avatar size={100} icon={<UserOutlined />} alt="Founder Avatar" />
            <Title level={4} style={{ color: "white", marginTop: "10px" }}>Talha Masood</Title>
            <Paragraph style={{ color: "white" }}>Co-Founder & CTO</Paragraph>
          </FounderCard>
        </FounderContainer>
      </StyledCard>
    </PageContainer>
  );
};

export default About;
